export default "__VITE_ASSET__vRbzMU3a__"